import { Divider, Skeleton } from "@mui/material";
import { useGetRolesForUser } from "../../http";
import { IUserRole } from "../../models";
import { ViewList } from "../ViewList";
import { RolesListItem } from "./RolesListItem";

interface IProps {
  userId: string;
}

const RolesList = (props: IProps) => {
  const { data: roles, isLoading } = useGetRolesForUser(props.userId);

  const roleSortFunction = (a: IUserRole, b: IUserRole) => {
    if (a.isPrimaryRole && !b.isPrimaryRole) {
      return -1;
    }

    if (!a.isPrimaryRole && b.isPrimaryRole) {
      return 1;
    }

    if (a.engagementPercentage !== b.engagementPercentage) {
      return b.engagementPercentage - a.engagementPercentage;
    }

    return a.name.localeCompare(b.name);
  };

  return (
    <ViewList
      dataSource={roles?.sort(roleSortFunction)}
      isLoading={isLoading}
      divider={<Divider variant="dashed" sx={{ mx: 1 }} />}
      spacing={0}
      renderSkeleton={(index) => <Skeleton key={index} variant="rectangular" sx={{ m: { xs: 0.5, sm: 1 } }} />}
      renderItem={(item, index) => <RolesListItem role={item} key={index} sx={{ py: { xs: 0.5, sm: 1 } }} />}
    />
  );
};

export { RolesList };
